import { txtmodules, imgmodules } from 'Flow2/components/Article/Helpers/EditorHelper';
import { faUsers, faTimes } from '@fortawesome/free-solid-svg-icons';
export const RED = '#d5001c';
export const HISTORYTYPE = 'historyType';
export const STATISTICTYPE = 'statisticType';
export const MODALTYPE = 'modalType';
export const CLOSED = 'closed';
export const OPEN = 'open;'
export const ICON_RED = { color: RED };
export const TIMES = [100, 100, 1000, 1000, 1500, 2000, 5000];
export const FONTSIZE_TIME = 1000;
export const FONTSIZE_WAIT = 100;
export const MILLISECONDS = 3000;
export const EDITOR = "editortype";
export const FONTSIZE_MAX = 5;
export const FONTSIZE_MIN = 0;
export const CONTACT_PAGE = "contactPage";
export const ADMIN_PAGE = "adminPage";
export const SETTING_PAGE = "settingsPage";
export const TEXT = "text";
export const SUBTABLE = "subtable";
export const FACETYPE = 'faceType';
export const MINMAX = 'minmax';
export const BEGIN_OR = { "field": "", "type": "BEGIN_OR", "value": "" };
export const END_OR = { "field": "", "type": "END_OR", "value": "" };
export const BEGIN_GROUP = { "field": "", "type": "BEGIN_GROUP", "value": "" };
export const END_GROUP = { "field": "", "type": "END_GROUP", "value": "" };
export const FULLTXT = 'fulltext';
export const BYFIELDS = 'byfields';
export const IS_FULLTOFIELDS = 'isFullToFields';
export const INPUT_NUM = 'input_number';
export const DUMMY_SORT = 9999999;
export const DUMMY_SORT_DESC = 1000000000;
export const DUMMY_SORT_ASC = 9999999999;

export const RENAME_OBJ = {
    "roomaddclips": "roomresorted",
    "roomremovelips": "roomresorted",
    "roomaddclips_related": "roomremovelips",
    "roomremovelips_related": "roomaddclips",
    "roomaddclips_changed": "roomresorted",
    "roomremovelips_changed": "roomresorted"
}


//COLOR THEME
export const DARK_COLOR = {
    bg_primary: "#000000",
    bg_second: "#202020",
    bg_third: "#404040",
    bg_fourth: "#606060",
    bg_fifth: "#808080",
}

export const LIGHT_COLOR = {
    bg_primary: "#ffffff",
    bg_second: "#f6f7f8",
    bg_third: "#eaeaea",
    bg_fourth: "#cacaca",
    bg_fifth: "#aaaaaa",
    bg_sixth: "#808080"
}

export const SEARCH_LIST = {
    searchlisttext: {
        inputType: 'inputtype',
        intl: 'customdata.searchlist.textinput',
        name: 'searchlisttext',
    },
    projectslist: {
        inputType: 'dropdowntype',
        intl: 'customdata.searchProjects',
        name: 'projectslist',
        data: []
    },

    checkboxItems: [
        {
            inputType: 'checkboxtype',
            intl: 'customdata.searchlist.owner',
            name: 'owner',
            data: []
        },
        {
            inputType: 'checkboxtype',
            intl: 'customdata.searchlist.public',
            name: 'public',
            data: []
        },
        {
            inputType: 'checkboxtype',
            intl: 'customdata.searchlist.shared',
            name: 'shared',
            data: []
        }
    ]
}

export const SEARCHLIST_OBJ = "shareSearchList";
export const UPLOAD_MEMBERS_LEVELS = ["level2", "level3", "level4", "level5", "level6"];


//export const SPLASH_PROJECTS = [208, 152];
export const SPLASH_PROJECTS = [152];
export const SPLASH_PROJECT_NAMES = ["NLW Public Frontend"];
export const SPLASH_PROJECT = 152;

export const SPLASH_PAGE_ITEMS = [
    { name: "sp_img", intl: "data.splash.img", type: "editortype", required: true, modules: imgmodules },
    { name: "sp_txt_en_int", intl: "data.splash.txt_en_int", type: "editortype", required: true, modules: txtmodules },
    { name: "sp_txt_cy_int", intl: "data.splash.txt_cy_int", type: "editortype", required: true, modules: txtmodules },
    { name: "sp_txt_en_ext", intl: "data.splash.txt_en_ext", type: "editortype", required: true, modules: txtmodules },
    { name: "sp_txt_cy_ext", intl: "data.splash.txt_cy_ext", type: "editortype", required: true, modules: txtmodules }
];

export const PLAYEROVERLAY_ITEMS = [
    { name: "po_txt_en_int", intl: "data.splash.txt_en_int", type: "editortype", required: true, modules: txtmodules },
    { name: "po_txt_cy_int", intl: "data.splash.txt_cy_int", type: "editortype", required: true, modules: txtmodules },
    { name: "po_txt_en_ext", intl: "data.splash.txt_en_ext", type: "editortype", required: true, modules: txtmodules },
    { name: "po_txt_cy_ext", intl: "data.splash.txt_cy_ext", type: "editortype", required: true, modules: txtmodules }
];

export const CONTENTWARNING_ITEMS = [
    { name: "cw_title_en_int", intl: "data.splash.title_en_int", type: "editortype", required: true, modules: txtmodules },
    { name: "cw_title_cy_int", intl: "data.splash.title_cy_int", type: "editortype", required: true, modules: txtmodules },
    { name: "cw_txt_en_int", intl: "data.splash.desc_en_int", type: "editortype", required: true, modules: txtmodules },
    { name: "cw_txt_cy_int", intl: "data.splash.desc_cy_int", type: "editortype", required: true, modules: txtmodules },
    { name: "cw_link_en_int", intl: "data.splash.link_en_int", type: "editortype", required: true, modules: txtmodules },
    { name: "cw_link_cy_int", intl: "data.splash.link_cy_int", type: "editortype", required: true, modules: txtmodules },
    { name: "cw_check_en_int", intl: "data.splash.check_en_int", type: "editortype", required: true, modules: txtmodules },
    { name: "cw_check_cy_int", intl: "data.splash.check_cy_int", type: "editortype", required: true, modules: txtmodules }
];

export const SPLASH_BTN_ITEMS = [
    { name: "cancel", intl: "data.splash.cancel", icon: faTimes, htmlclass: "custom-splashbtn", onClick: "closePopUp" },
    { name: "save", intl: "data.splash.save", icon: faUsers, htmlclass: "custom-splashbtn custom-active", onClick: "confirmPopUp" },
]

export const SPLASH_PAGE = "splash_page";
export const PLAYER_OVERLAY = "player_overlay";
export const CONTENT_WARNING = "content_warning";

export const SPLASH_TABS = [
    { name: SPLASH_PAGE, intl: "data.splash.tab_splashpage", type: "btntab", isActive: true },
    { name: PLAYER_OVERLAY, intl: "data.splash.tab_playeroverlay", type: "btntab" },
    { name: CONTENT_WARNING, intl: "data.splash.tab_contentwarning", type: "btntab" },
];

export const ACTIVE_BTN = {
    backgroundColor: '#d5001c',
    color: '#fff',
    border: '1px solid #d5001c'
}

//STATISTIC
export const ALL_ROOMS = false;
export const NEW_DESIGN = true;
export const DEV_TEST = false;
export const STATISTIC_CONTENT_ITEMS = [
    {
        name: "date", intl: "data.statistic.date", type: "dategroup",
        datePosFirst: "bottom-start", datePosSecond: "bottom-end",
        // current: new Date()
    },
]


export const STATISTIC_CUSTOM_TABLE = [
    { name: "clipid", intl: "data.statistic.clipid", type: "text" },
    { name: "title", intl: "data.statistic.title", type: "text" },
    { name: "views", intl: "data.statistic.views", type: "text" },
]

export const STATISTIC_TABLE_HEADER = [
    { name: "title", intl: "data.statistic.room", type: "text", htmlclass: "statisticview-column-xl" },
    { name: "viewsvisits", intl: "data.statistic.viewsvisits", type: "text" },
    { name: "viewslocations", intl: "data.statistic.viewslocations", type: "text" },
    { name: "visitsvisits", intl: "data.statistic.visitsvisits", type: "text" },
    { name: "visitslocations", intl: "data.statistic.visitslocations", type: "text" },
    {
        name: "clipsdata", intl: "data.statistic.clipsdata", type: "subtable",
        htmlclass: "statisticview-column-xxl",
        subheader: [
            { name: "clipid", intl: "data.statistic.clipid", type: "text" },
            { name: "title", intl: "data.statistic.title", type: "text" },
            { name: "views", intl: "data.statistic.views", type: "text" },
        ]
    },
];


export const MULTISORT_ITEMS = [
    { name: "step_0", intl: "data.multisort.step_0", type: "dropdown", data: [] },
    { name: "step_1", intl: "data.multisort.step_1", type: "dropdown", data: [] },
    { name: "step_2", intl: "data.multisort.step_2", type: "dropdown", data: [] },
]


export const ROW = 'row';
export const DD = 'dropdown';
export const XX = 'XXXXXX';

export const FLEX_DATE_DATA = [
    {
        name: 'from', type: 'row', data: [
            { name: 'd', value: '', intl: 'flex.day', reqOthers: ['m', 'y'], reqMax: 31 },
            { name: 'm', value: '', intl: 'flex.month', reqOthers: ['y'], reqMax: 12, checkOthers: ['d', 'y'] },
            { name: 'y', value: '', intl: 'flex.year', reqLen: 4, checkOthers: ['d', 'm'] }
        ]
    },
    {
        name: 'to', type: 'row', disLine: true, data: [
            { name: 'd', value: '', intl: 'flex.day', reqOthers: ['m', 'y'], reqMax: 31 },
            { name: 'm', value: '', intl: 'flex.month', reqOthers: ['y'], reqMax: 12, checkOthers: ['d', 'y'] },
            { name: 'y', value: '', intl: 'flex.year', reqLen: 4, checkOthers: ['d', 'm'] }
        ]
    },
    {
        name: 'mode', type: 'dropdown', data: [
            { name: 'modus', value: XX, intl: 'flex.modus' },
            { name: 'ca', value: 'ca', intl: 'flex.ca', reqOthers: ['y'], buff: '08' },
            // { name: 'begin', value: 'anfang', intl: 'flex.begin' },
            // { name: 'middle', value: 'mitte', intl: 'flex.middle' },
            // { name: 'end', value: 'ende', intl: 'flex.end' },
            { name: 'befor', value: 'vor', intl: 'flex.before', disableLine: true, reqOthers: ['y'], buff: '06' },
            { name: 'after', value: 'nach', intl: 'flex.after', disableLine: true, reqOthers: ['y'], buff: '10' },
            { name: 'from', value: 'ab', intl: 'flex.from', disableLine: true, reqOthers: ['y'], buff: '09' },
            { name: 'until', value: 'bis', intl: 'flex.until', disableLine: true, reqOthers: ['y'], buff: '07' },
        ]
    },
];

export const FLEX_DATE_OBJ = {
    'zeitraumjson': {
        '>=': [{ field: 'zeitraum_von', type: '<=' }, { field: 'zeitraum_bis', type: '>=' }],
        '<=': [{ field: 'zeitraum_von', type: '<=' }, { field: 'zeitraum_bis', type: '>=' }],
        'less_than': [{ field: 'zeitraum_bis', type: '<' }],
        'less_equal_than': [{ field: 'zeitraum_von', type: '<=' }],
        'equal': [{ field: 'zeitraum_von', type: '<=' }, { field: 'zeitraum_bis', type: '>=' }],
        'greater_equal_than': [{ field: 'zeitraum_bis', type: '>=' }],
        'greater_than': [{ field: 'zeitraum_von', type: '>' }]
    }
};

export const EMPTY_OBJ = {
    'to': { 'd': 0, 'm': 0, 'y': 0 }
}

export const CONTAINS = 'contains';
